import { useEffect } from "react";

/**
 * JsonLd: renders one or many JSON-LD schemas as <script type="application/ld+json">.
 * Injects into <head>; auto-cleans on unmount/update to avoid duplicates between routes.
 *
 * Usage:
 *   <JsonLd id="business" data={localBusinessSchema()} />
 *   <JsonLd id="business" data={[schemaA, schemaB]} />
 */
export const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return;
    const items = Array.isArray(data) ? data : [data];
    const nodes = items.map((obj, idx) => {
      const el = document.createElement("script");
      el.type = "application/ld+json";
      el.setAttribute("data-schema-id", `${id}-${idx}`);
      el.text = JSON.stringify(obj);
      document.head.appendChild(el);
      return el;
    });
    return () => nodes.forEach((n) => n.parentNode && n.parentNode.removeChild(n));
  }, [id, JSON.stringify(data)]); // eslint-disable-line react-hooks/exhaustive-deps
  return null;
};

export default JsonLd;
